import React from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { QuestionDifficulty } from 'types';
import { FaChevronUp } from 'react-icons/fa6';
import { generateDifficultyColor } from 'src/utils/color';
import { Img } from 'react-image';
import { GiClick } from 'react-icons/gi';
import { Tooltip } from '@mui/material';
import { useThemeContext } from 'src/context/ThemeProvider';

interface Props {
	isOpen: boolean;
	question: {
		serialNumber: number;
		title: string;
		level: string;
		score: number;
		timeTaken: string;
		skillsAssessed: { _id: string; name: string; isSoftSkill: boolean }[];
	};
}

const AccordianTitleQuestionComponent = ({ isOpen, question }: Props) => {
	const customStyleObject = {
		color: generateDifficultyColor(question.level as QuestionDifficulty),
	};
	const { themeMode } = useThemeContext();
	return (
		<div className="px-[10px] py-[6px] flex items-center dark:bg-[#18222D] border-b-[1px] border-solid dark:border-gray-700">
			<div className="flex min-w-[200px] gap-[3px]">
				<div>{question.serialNumber}.</div>
				<div>
					<div className="max-w-[160px] truncate">
						{question.title ? (
							<>{question.title}</>
						) : (
							<div className="flex gap-[6px] items-center">
								Click to expand
								<GiClick />
							</div>
						)}
					</div>
					<div style={customStyleObject} className={`text-[10px] font-medium`}>
						{question.level}
					</div>
				</div>
			</div>

			<div className="text-base font-medium dark:text-[#F2F2F5] min-w-[60px] ">
				{question.score}
				<span className="text-[8px]">/10</span>
			</div>

			<div className="text-sm font-medium dark:text-[#C7C9D9] min-w-[100px]">{question.timeTaken}</div>

			<div className="grow-2 flex flex-wrap gap-2">
				{question?.skillsAssessed?.map(s => {
					const backgroundStyleObject =
						themeMode === 'dark'
							? {
									background: !s.isSoftSkill
										? 'linear-gradient(#242C40, #242C40) padding-box, linear-gradient(to right, #5b8def, #0063f7, #73dfe7, #0063f7)' // linear-gradient(#111E2C, #111E2C)
										: '#242C40',
							  }
							: {};

					return (
						<div
							key={s._id}
							style={backgroundStyleObject}
							className={`px-[9px] py-[1px] text-sm font-medium dark:text-[#E4E4EB] w-max rounded-[5px] border-[0.5px] ${
								s.isSoftSkill
									? 'border-solid border-[#C7D0F2] border bg-[#CDF] text-[#7777E7]'
									: 'border border-[#C7D0F2] bg-[#CDF] text-[#7777E7]'
							} `}
						>
							{s.name}
							{!s.isSoftSkill ? (
								<Tooltip title="Technical Skill">
									<span>
										<Img
											className="ml-[4px] inline-block align-text-bottom"
											loading="lazy"
											src="/assets/checkCircle.svg"
											alt="checkCircle"
											width="14"
											height="14"
										/>
									</span>
								</Tooltip>
							) : null}
						</div>
					);
				})}
			</div>

			<div className="min-w-[46px] flex justify-center">{isOpen ? <FaChevronUp /> : <FaChevronDown />}</div>
		</div>
	);
};

export default AccordianTitleQuestionComponent;
